import { registerDynamicCallback } from './servdUtils.js';

/**
 * Simple lazy loading implementation using Intersection Observer API
 * Handles both img elements and div elements with background images
 * Compatible with Servd's dynamic includes
 */
export function initLazyLoad() {
  // Get all elements that need lazy loading
  const lazyImages = document.querySelectorAll('img[data-src]');
  const lazyBackgrounds = document.querySelectorAll('div[data-src]');

  if (!lazyImages.length && !lazyBackgrounds.length) return;
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const src = element.dataset.src;
        
        if (element.tagName.toLowerCase() === 'img') {
          // Handle img elements
          const img = new Image();
          img.onload = function() {
            element.src = src;
            element.removeAttribute('data-src');
            element.classList.add('is-loaded');
          };
          img.onerror = function() {
            element.classList.add('load-error');
          };
          img.src = src;
        } else {
          // Handle div elements with background images
          element.style.backgroundImage = `url(${src})`;
          element.removeAttribute('data-src');
          element.classList.add('is-loaded');
        }
        
        // Stop observing this element
        observer.unobserve(element);
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.01
  });
  
  // Start observing all lazy elements
  lazyImages.forEach(img => imageObserver.observe(img));
  lazyBackgrounds.forEach(div => imageObserver.observe(div));
}

/**
 * Initialize lazy loading and register it with Servd utilities
 */
export function initLazyLoadWithServd() {
  // Register the lazy loading function to be re-run when dynamic content loads
  registerDynamicCallback(initLazyLoad, 'lazy-loading');
  
  // Initial lazy loading setup
  initLazyLoad();
  
  // Add manual check function for debugging
  window.checkLazyImages = function() {
    const lazyImages = document.querySelectorAll('img[data-src]');
    const lazyBackgrounds = document.querySelectorAll('div[data-src]');
    
    return {
      lazyImages: lazyImages.length,
      lazyBackgrounds: lazyBackgrounds.length
    };
  };
} 